export const toMonthInputValue = (date?: string | null) => {
  if (!date) return '';
  return date.length >= 7 ? date.slice(0, 7) : date;
};

export const monthInputToApiDate = (date?: string | null) => {
  if (!date) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
  if (/^\d{4}-\d{2}$/.test(date)) return `${date}-01`;
  return date;
};

export const profileMonthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const formatProfileMonth = (date?: string | null) => {
  if (!date) return '';

  const [yearValue, monthValue] = date.split('-');
  const year = Number(yearValue);
  const month = Number(monthValue);

  if (!year || !month || month < 1 || month > 12) return yearValue || '';

  return `${profileMonthNames[month - 1]} ${String(year).slice(-2)}`;
};
